import { useEffect } from 'react';
import { useMediaQuery } from './useMediaQuery';

const MOBILE_QUERY = '(max-width: 767px)';

/** Clear a stale open request when navigation stops being a mobile drawer. */
export function useMobileDrawer(open: boolean, onClose: () => void): boolean {
  const isMobile = useMediaQuery(MOBILE_QUERY);

  useEffect(() => {
    if (open && !isMobile) onClose();
  }, [open, isMobile, onClose]);

  return open && isMobile;
}
